import StickyWrapper from 'src/components/laws/StickyWrapper'
import PageTitle from 'src/components/typography/PageTitle'

export default StickyWrapper()(PageTitle)
